import React from 'react';
import { MenuButton, MenuButtonConfig } from './MenuButton';


type Props = {
  buttons: MenuButtonConfig[];
}

export const MenuButtonsList = (props: Props): React.ReactElement => {
  return (
    <div className="w-full">
      {
        props.buttons.map(btn => {
          return <MenuButton
            key={btn.label}
            label={btn.label}
            onClick={btn.onClick}
            description={btn.description}
            image={btn.image}
            textAlign={btn.textAlign}
            className="mb-5"
          />
        })
      }
    </div>
  )
}
